/**
 * Deep A: a Classic-style warm-up down a staircase of brick shelves, with the Deep's first clock
 * waiting in a cradle beside the inbox (docs/spec/03 §3).
 */

import type { CaveDef } from '../types';

export const deepA: CaveDef = {
  id: 'A',
  name: 'DESCENT',
  hint: 'Take the clock for ten more seconds, then go down.',
  intermission: false,
  colors: [6, 15, 7],
  diamondValue: 15,
  extraValue: 20,
  fill: { base: '.', items: [['r', 11], ['d', 6], [' ', 2]] },
  levels: [
    { seed: 5101, diamonds: 12, time: 150 },
    { seed: 5102, diamonds: 14, time: 140 },
    { seed: 5103, diamonds: 15, time: 130 },
    { seed: 5104, diamonds: 17, time: 120 },
    { seed: 5105, diamonds: 19, time: 110 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
    'W....??????????????????????????????????W',
    'W.P..??????????????????????????????????W',
    'W.....t.???????????????????????????????W',
    'W....www???????????????????????????????W',
    'W??????????????????????????????????????W',
    'Wwwwwwwwwwwwww?????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W?????????????????????????dd???????????W',
    'W?????????wwwwwwwwwwwwwwww?????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W????????????????????????????????dd????W',
    'W?????????????????wwwwwwwwwwwwwwww?????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W?????????????????????????wwwwwwwwwwwwwW',
    'W???????????????????????....d....d.....W',
    'W???????????????????????.......d....X..W',
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
  ],
};
